import { URI_MESSAGES_SERVICE } from '@/config/config';
export default async ({ rootState, commit }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await fetch(
    `${URI_MESSAGES_SERVICE}users/open-help-request`,
    opts,
  );
  const jsonResult = await response.json();
  if (response.status >= 400) {
    throw new Error(jsonResult);
  }
  commit('consumerOpenMessages', jsonResult.data);
  return jsonResult.data;
};
